export const getFieldMapping = culture => {
    const cartSellableField = {
        "en-au": "custitemavailwebau",
        "en-nz": "custitemavailwebnz",
        "en-us": "custitemavailwebusa",
        "en-eu": "custitemavailwebnetherlands",
        "en-gb": "custitemavailwebnetherlands"
    };
    return cartSellableField[culture] ?? null;
};
